// import React, { useState } from 'react'
// import { Card } from "flowbite-react";
// import IsRequired from '../../components/lmx-required/lmx-required';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Popup from '../../components/Popup/PopUp';
// import { useRef } from "react";
// import emailjs from '@emailjs/browser';
// import websitedev from "../../assets/Contactimages/websitedev.png"
// import websitemain from "../../assets/Contactimages/websitemain.png"
// import poster from "../../assets/Contactimages/poster.png"
// import webdes from "../../assets/Contactimages/webdes.png"
// import marketing from "../../assets/Contactimages/marketing.png"





// const Contact = () => {
//   const notify = () => toast("Wow so easy!");
//   const [popUp, setPopUp] = useState(false);
//   const form = useRef();
//   const sendEmail = (e) => {
//     e.preventDefault();
//     emailjs
//       .sendForm(
//         "service_ueyaags",
//         "template_g8pip2r",
//         form.current,
//         "QziXxXyzGFP6V5jU4"
//       )
//       .then(
//         (result) => {
//           console.log(result.text);
//         },
//         (error) => {
//           console.log(error.text);
//         }
//       );
//     openPop();
//     e.target.reset();
//   };
//   function openPop() {
//     setPopUp(true);
//   }
//   return (
//     <div >
//       <section className="bg-white dark:bg-gray-900 m-5">

//         <div className="mx-auto max-w-screen-sm text-center lg:mb-16 mb-8">


//         </div>
//         {/* </div> */}
//         <div className="container mx-auto">
//           <div className="-mx-4 flex flex-wrap lg:justify-between">
//             <div className="w-full px-4 lg:w-1/2 xl:w-6/12">
//               <div className="mb-5 max-w-[570px] lg:mb-0 rounded-lg bg-white-800 p-6 shadow-xl border-gray-400 outline-red">

//                 <h2 className="text-dark mb-6 text-[32px] font-bold uppercase sm:text-[40px] lg:text-[36px] xl:text-[40px]" >
//                   For Enquiry </h2>

//                 <div className="mb-8  flex w-full max-w-[370px]">
//                   <div className=" text-primary mr-6 flex h-[60px] w-full max-w-[60px] items-center justify-center overflow-hidden rounded bg-opacity-5 sm:h-[70px] sm:max-w-[70px]">
//                     <img src={websitedev} alt="career" />
//                   </div>
//                   <div className="w-full">
//                     <h4 className="text-dark mt-5 text-xl font-bold">Website Development</h4>
//                   </div>
//                 </div>

//                 <div className="mb-8  flex w-full max-w-[370px]">
//                   <div className="bg-primary text-primary mr-6 flex h-[60px] w-full max-w-[60px] items-center justify-center overflow-hidden rounded bg-opacity-5 sm:h-[70px] sm:max-w-[70px]">
//                     <img src={websitemain} alt="Counselling & Admission" />
//                   </div>
//                   <div className="w-full">
//                     <h4 className="text-dark mt-5 text-xl font-bold">Website Maintaince</h4>
//                   </div>
//                 </div>
//                 <div className="mb-8  flex w-full max-w-[370px]">
//                   <div className="bg-primary text-primary mr-6 flex h-[60px] w-full max-w-[60px] items-center justify-center overflow-hidden rounded bg-opacity-5 sm:h-[70px] sm:max-w-[70px]">
//                     <img src={poster} alt="Email" />
//                   </div>
//                   <div className="w-full">
//                     <h4 className="text-dark mt-5 text-xl font-bold">Poster Making</h4>
//                   </div>
//                 </div>
//                 <div className="mb-8  flex w-full max-w-[370px]">
//                   <div className="bg-primary text-primary mr-6 flex h-[60px] w-full max-w-[60px] items-center justify-center overflow-hidden rounded bg-opacity-5 sm:h-[70px] sm:max-w-[70px]">
//                     <img src={marketing} alt="Email" />
//                   </div>
//                   <div className="w-full">
//                     <h4 className="text-dark mt-5 text-xl font-bold">Marketing</h4>
//                   </div>
//                 </div>

//               </div>
//             </div>


//             <div className="w-full px-4 lg:w-1/2 -mt-5 xl:w-6/12">
//               <div className="relative rounded-lg bg-white-800 p-6 shadow-xl border-gray-400 outline-red sm:p-12">
//                 <h2 className="text-dark mb-6 text-[32px] font-bold uppercase sm:text-[40px] lg:text-[36px] xl:text-[40px]" >
//                   Get in touch</h2>

//                 <form ref={form} onSubmit={sendEmail} className="space-y-10 mt-10">

//                   <div className="grid grid-cols-1 gap-6 gap-x-8 gap-y-6 sm:grid-cols-2">
//                     <div>
//                       <label htmlFor="first-name" className="block text-sm font-semibold leading-6 text-gray-900">
//                         First name
//                         <IsRequired />
//                       </label>
//                       <div className="mt-2.5">
//                         <input
//                           placeholder='Enter your First Name'
//                           type="text"
//                           id="first-name"
//                           required

//                           className="block w-full rounded-md border-0 px-3.5 py-2
//                    bg-gray-20  text-gray-900
//                     shadow-sm ring-1  ring-blue-900 placeholder:text-gray-500
//                      focus:ring-2  focus:ring-blue-900 sm:text-sm sm:leading-6"
//                         />
//                       </div>
//                     </div>

//                     <div>
//                       <label htmlFor="email" className="block text-sm font-semibold leading-6 text-gray-900">
//                         Email
//                         <IsRequired />
//                       </label>
//                       <div className="mt-2.5">
//                         <input
//                           type="email"
//                           name="email"
//                           id="email"
//                           placeholder='Enter your Email'
//                           required
//                           className="block w-full rounded-md border-0 px-3.5 py-2
//                    bg-gray-20  text-gray-900
//                     shadow-sm ring-1  ring-blue-900 placeholder:text-gray-500
//                      focus:ring-2  focus:ring-blue-900 sm:text-sm sm:leading-6"
//                         />
//                       </div>
//                     </div>


//                     <div>
//                       <label htmlFor="phone-number" className="block text-sm font-semibold leading-6 text-gray-900">
//                         Phone Number
//                         <IsRequired />

//                       </label>
//                       <div className="mt-2.5">
//                         <input
//                           type="tel"
//                           name="phone-number"
//                           id="phone-number"
//                           placeholder='1234567890'
//                           required


//                           className="block w-full rounded-md border-0 px-3.5 py-2
//                   bg-gray-20 border-blue-900 focus:border-blue-900 text-gray-900
//                    shadow-sm ring-1  ring-blue-900 placeholder:text-gray-500
//                     focus:ring-2  focus:ring-blue-900 sm:text-sm sm:leading-6"
//                         />
//                       </div>
//                     </div>


//                     <div>
//                       <label htmlFor="city" className="block text-sm font-semibold leading-6 text-gray-900">
//                         City
//                         <IsRequired />

//                       </label>
//                       <div className="mt-2.5">
//                         <input
//                           type="city"
//                           name="city"
//                           id="city"
//                           placeholder='Enter your City'
//                           required


//                           className="block w-full rounded-md border-0 px-3.5 py-2
//                   bg-gray-20 border-blue-900 focus:border-blue-900 text-gray-900
//                    shadow-sm ring-1  ring-blue-900 placeholder:text-gray-500
//                     focus:ring-2  focus:ring-blue-900 sm:text-sm sm:leading-6"
//                         />
//                       </div>
//                     </div>




//                     <div className="sm:col-span-2">
//                       <label htmlFor="message" className="block text-sm font-semibold leading-6 text-gray-900">
//                         Message
//                         <IsRequired />

//                       </label>
//                       <div className="mt-2.5">
//                         <textarea
//                           name="message"
//                           id="message"
//                           rows={2}
//                           placeholder='Leave our message'
//                           required

//                           className="block w-full rounded-md border-0 px-3.5 py-2
//                   bg-gray-20 border-blue-900 focus:border-blue-900 text-gray-900
//                    shadow-sm ring-1  ring-blue-900 placeholder:text-gray-500
//                     focus:ring-2  focus:ring-blue-900 sm:text-sm sm:leading-6"

//                         />
//                       </div>
//                     </div>


//                   </div>
//                   <div className="mt-10">
//                     <button
//                       type="submit"
//                       className="block w-full rounded-md bg-blue-900 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
//                     >
//                       Send Message
//                     </button>
//                   </div>
//                 </form>
//                 <Popup trigger={popUp} style={{ backgroundColor: "#4BB543" }}>
//                   <h2 >Success!</h2>
//                   <br></br>
//                   <h3 >Form submitted</h3>
//                 </Popup>
//                 <div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>




//     </div>

//   )
// }

// export default Contact



import india from "../../assets/contact/india.png"
import singapore from "../../assets/contact/singapore.png"
import logo from "../../assets/logo/logo.jpg"
import { Link, useNavigate } from "react-router-dom";
import publici from "../../assets/contact/public.png"
import customer from "../../assets/contact/customer.png"
import analyst from "../../assets/contact/analyst.png"
import phone from "../../assets/contact/phone.png"
import settings from "../../assets/contact/settings.png"
import upgrade from "../../assets/contact/upgrade.png"
import cancel from "../../assets/contact/cancel.png"
import support from "../../assets/contact/support.png"
import React, { useEffect, useRef, useState } from "react";
import { Collapse, Dropdown } from "flowbite";
import MMFooter from "../../components/Footer/MMFooter";
import { SingleFooter } from "../../route";
const Contact = () => {

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    scrollToTop();
  }, []);

  let getYear = () => {
    let currentYear = new Date().getFullYear();
    return currentYear;
  };
  const navigate = useNavigate();
  const target = useRef(null);
  const trigger = useRef(null);
  const [bool, setbool] = useState(false)
  //Mobile Navbar func
  const mobile = () => {
    const hammenu = target.current;
    const nav = trigger.current;

    const navoptions = {
      onCollapse: () => { },
      onExpand: () => { },
      onToggle: () => { },
    };
    const mobnav = new Collapse(hammenu, nav, navoptions);
    mobnav.expand();
    mobnav.collapse();

    if (bool === true) {
      mobnav.collapse();
    }
  };


  //Other Dropdown function


  useEffect(() => {
    mobile();

  }, []);

  return (
    <div>

      <nav className="bg-white dark:bg-white-900 fixed w-full z-20 p-1 top-0 left-0 border-b border-gray-200 dark:border-gray-600  ">
        <div className="xl:container m-auto px-6 md:px-12">
          <div className="flex flex-wrap items-center justify-between gap-6 md:py-3 md:gap-0">
            <div className="w-full flex justify-between lg:w-auto">
              <a href="/" className="flex items-center">
                <img src={logo} className="h-10 mr-4" alt="Making Minds Technologies Logo" />
                <span className="text-2xl font-bold font-mfont">Making Minds Technologies</span>
              </a>
              <div className="flex md:order-2 overflow-hidden">
                <button
                  data-collapse-toggle="navbar-sticky"
                  id="hammenu"
                  ref={trigger}
                  type="button"
                  className="inline-flex items-center p-4 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600 overflow-visible"
                  aria-controls="navbar-sticky"
                  aria-expanded="false"
                >
                  <span className="sr-only">Open main menu</span>
                  <svg
                    className="w-6 h-6"
                    aria-hidden="true"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>
            <div
              className="items-center justify-between hidden w-full md:flex md:w-auto md:order-1"
              id="navbar-sticky"
              aria-current="page"
              ref={target} >
              <div className="w-full space-y-2 border-primary/10 dark:border-gray-700 flex flex-col -ml-1 sm:flex-row lg:space-y-0 md:w-max lg:border-l">
                {/* <a href="/about"
                  className="text-black  font-semibold font-mfont block px-4 py-2 pl-3 pr-4
                          text-lg">About</a>
                <a href="/"
                  className="text-black  font-semibold font-mfont block px-4 py-2 pl-3 pr-4
                          text-lg">Products</a> */}
                <a href="#inquires"
                  className="text-black  font-semibold font-mfont block px-4 py-2 pl-3 pr-4 
                         text-lg">General Inquires</a>

                <a href="#offices"
                  className="text-black  font-semibold font-mfont block px-4 py-2 pl-3 pr-4 
                         text-lg">Our offices</a>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <section className="text-white bg-white" >
        <div className="container px-5 py-20 mx-auto">
          <div className="flex flex-col text-center w-full mb-5">
            <h3 className="text-center text-2xl mt-5 lg:text-4xl mb-5 font-medium text-black font-mfont">
              Looking for something in particular?
            </h3>
            <p className="text-center text-2xl font-medium font-mfont  text-black ">We're here to help.
            </p>
          </div>
          <div className="flex flex-wrap ">
            <div className="lg:w-1/4 md:w-1/2 p-4 w-full">
              <div className="flex rounded-lg h-full bg-white border p-8 flex-col">
                <div className="flex items-center mb-3">
                  <img
                    className="mx-auto w-12"
                    src={phone}
                    alt="phone" />
                </div>
                <h2 className="text-gray-700  text-center text-xl mb-5 font-medium">Looking for a demo,
                  or have questions about our products and pricing?</h2>
                <div className="flex-grow text-center">
                  <a href="mailto:makingminds@rediffmail.com"
                    className="leading-relaxed text-md  font-medium text-blue-600">
                    makingminds@rediffmail.com </a>
                </div>
              </div>
            </div>

            <div className="lg:w-1/4 md:w-1/2 p-4 w-full">
              <div className="flex rounded-lg h-full bg-white border p-8 flex-col">
                <div className="flex items-center mb-3">
                  <img
                    className="mx-auto w-12"
                    src={settings}
                    alt="settings" />
                </div>
                <h2 className="text-gray-700  text-center text-xl mb-5 font-medium"> Need help with adding licenses,
                  changing plans, or additional services?</h2>
                <div className="flex-grow text-center">
                  <a href="mailto:teammakingminds@gmail.com"
                    className="leading-relaxed text-md  font-medium text-blue-600">
                    teammakingminds@gmail.com </a>
                </div>
              </div>
            </div>

            <div className="lg:w-1/4 md:w-1/2 p-4 w-full">
              <div className="flex rounded-lg h-full bg-white border p-8 flex-col">
                <div className="flex items-center mb-3">
                  <img
                    className="mx-auto w-12"
                    src={upgrade}
                    alt="upgrade" />
                </div>
                <h2 className="text-gray-700  text-center text-xl mb-5 font-medium"> Want to renew your subscription or need details about your
                  current plan?</h2>
                <div className="flex-grow text-center">
                  <a href="mailto:teammakingminds@gmail.com"
                    className="leading-relaxed text-md  font-medium text-blue-600">
                    teammakingminds@gmail.com </a>
                </div>
              </div>
            </div>

            <div className="lg:w-1/4 md:w-1/2 p-4 w-full">
              <div className="flex rounded-lg h-full bg-white border p-8 flex-col">
                <div className="flex items-center mb-3">
                  <img
                    className="mx-auto w-12"
                    src={cancel}
                    alt="cancel" />
                </div>
                <h2 className="text-gray-700  text-center text-xl mb-5 font-medium">Need to cancel your
                  subscription?
                  We're sad to see you go, but ready to help.</h2>
                <div className="flex-grow text-center">
                  <a href="mailto:makingminds@rediffmail.com"
                    className="leading-relaxed text-md  font-medium text-blue-600">
                    makingminds@rediffmail.com </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className="text-white bg-mcolor" id="inquires">
        <div className="container px-5 py-10 mx-auto">
          <div className="flex flex-col text-center w-full mb-5">
            <h3 className="text-center text-4xl mt-10  mb-5 font-medium text-white font-mfont">
              General Inquiries
            </h3>
            <p className="text-center text-2xl  text-white font-mfont">Want to get in touch? Drop us a line.
            </p>
          </div>
          <div className="flex flex-wrap ">
            <div className="p-4 md:w-1/3">
              <div className="flex rounded-lg h-full bg-white p-8 flex-col">
                <div className="flex items-center mb-3">
                  <img
                    className="mx-auto w-24"
                    src={publici}
                    alt="public"
                  />
                </div>
                <h2 className="text-gray-900  text-center text-3xl mb-5 font-mfont font-semibold"> Public Relations</h2>

                <div className="flex-grow text-center">
                  <a href="mailto:makingminds@rediffmail.com"
                    className="leading-relaxed text-xl  font-medium text-blue-600">
                    makingminds@rediffmail.com </a>
                </div>
              </div>
            </div>

            <div className="p-4 md:w-1/3">
              <div className="flex rounded-lg h-full bg-white p-8 flex-col">
                <div className="flex items-center mb-3">
                  <img
                    className="mx-auto w-24"
                    src={analyst}
                    alt="illustration"
                  />
                </div>
                <h2 className="text-gray-900  text-center text-3xl mb-5 font-mfont font-semibold"> Analyst Relations</h2>
                <div className="flex-grow text-center">
                  <a href="mailto:makingminds@rediffmail.com"
                    className="leading-relaxed text-xl  font-medium text-blue-600">
                    makingminds@rediffmail.com </a>
                </div>
                {/* <div className="flex-grow text-center">
                  <a href="tel:+91 9566344051 "
                    className="leading-relaxed text-xl  font-medium text-blue-600">
                    +91 9566344051 </a>
                </div> */}
              </div>
            </div>

            <div className="p-4 md:w-1/3">
              <div className="flex rounded-lg h-full bg-white p-8 flex-col">
                <div className="flex items-center mb-3">
                  <img
                    className="mx-auto w-24"
                    src={customer}
                    alt="illustration"
                  />
                </div>
                <h2 className="text-gray-900  text-center text-3xl mb-5 font-mfont font-semibold"> Customer Relations</h2>
                {/* <div className="flex-grow text-center">
                  <a href="tel: +91 9566344051 "
                    className="leading-relaxed text-xl  font-medium text-blue-600">
                    +91 9566344051 </a>
                </div> */}
                <div className="flex-grow text-center">
                  <a href="mailto:teammakingminds@gmail.com"
                    className="leading-relaxed text-xl  font-medium text-blue-600">
                    teammakingminds@gmail.com </a>
                </div>


              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="text-white bg-white" id="offices">
        <div className="container px-5 py-10 mx-auto">
          <div className="flex flex-col text-center w-full mb-10">
            <h3 className="text-center text-4xl mt-10  mb-5 font-medium text-black font-mfont">
              Our offices around the world
            </h3>
            <p className="text-center text-2xl  text-black font-mfont font-bold ">Connect with one of our global offices.
              or feel free to just send us a email. We won't mind!</p>
          </div>
          <div className="flex flex-wrap ">
            {/* <div className="p-4 md:w-1/3">
              <div className="flex rounded-lg h-full bg-white border p-8 flex-col">
                <div className="flex items-center mb-3">
                  <div className="w-8 h-8 mr-4 inline-flex justify-end  flex-shrink-0">
                    <img src={india} alt="india" />
                  </div>
                  <h2 className="text-gray-900 text-2xl  font-bold"> India</h2>
                </div>
                <div className="flex-grow">
                  <p className="leading-relaxed text-xl font-medium text-gray-700">
                    <p className="text-left text-black font-medium text-xl mb-3">Logimax Technologies (P) Limited</p>
                    Logimax Enclave, 24&25,<br />
                    L&T Bypass Karpagam University Junction, Near L&T Toll Gate 3,
                    Eachanari , Coimbatore,<br />
                    Tamil Nadu - 641 021,<br /> India </p>
                </div>
              </div>
            </div>
            <div className="p-4 md:w-1/3">
              <div className="flex rounded-lg h-full bg-white border p-8 flex-col">
                <div className="flex items-center mb-3">
                  <div className="w-8 h-8 mr-4 inline-flex justify-end  flex-shrink-0">
                    <img src={singapore} alt="singapore" />
                  </div>
                  <h2 className="text-gray-900 text-2xl  font-bold"> Singapore</h2>
                </div>
                <div className="flex-grow">
                  <p className="leading-relaxed text-xl font-medium text-gray-700">
                    <p className="text-left text-black font-medium text-xl mb-3">Logimax Technologies Pte Limited</p>
                    315A, Anchorvale Road,<br />
                    #05-152, Anchorvale Gardens,
                    Singapore 541315. </p>
                </div>
              </div>
            </div> */}
            <div className="p-4 md:w-1/3">
              <div className="flex rounded-lg h-full bg-white border p-8 flex-col">
                <div className="flex items-center mb-3">
                  <div className="w-8 h-8 mr-4 inline-flex justify-end  flex-shrink-0">
                    <img src={support} alt="support" />
                  </div>
                  <h2 className="text-gray-900 text-2xl  font-bold"> ASK FOR SUPPORT</h2>
                </div>
                <div className="flex-grow">
                  <p className="leading-relaxed text-center text-md font-medium text-gray-700">
                    <p className="text-center text-black font-medium text-xl mb-3">Making Minds Technologies</p>
                    If you have any questions don't hesitate to contact us. </p>
                  <p className="text-center text-black font-medium text-lg mb-4">Monday to Saturday : 9:45 Am to 11:00 PM (IST)
                  </p>
                  <div className="flex-grow text-center mb-2">
                    <a href="mailto:makingminds@rediffmail.com"
                      className="leading-relaxed text-xl text-center  font-medium text-blue-600">
                      makingminds@rediffmail.com </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section >


      {/* <section className="bg-blue-900 py-16 ">
        <div className="container m-auto px-6 text-center md:px-12 lg:px-20">
          <h2 className="mb-5 text-4xl font-semibold font-mfont text-white md:text-4xl">
            Ready to do your best work?
          </h2>
          <h2 className="mb-8 text-3xl font-medium  text-white md:text-4xl">
            Let's get you started.
          </h2>
          <a
            href="#"
            className="relative flex h-12 w-full mx-auto items-center 
                        justify-center px-8 before:absolute before:inset-0 before:rounded
                         before:bg-blue-700 before:transition before:duration-300 hover:before:scale-105 
                         active:duration-75 active:before:scale-95 sm:w-max"
          >
            <Link to="/" className="relative text-xl flex font-semibold text-white ">Get Started
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none">
                <path d="M10 7L15 12L10 17" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>

            </Link >
          </a>
        </div>
      </section> */}
      <section className="py-10 lg:py-[50px] bg-mcolor dark:bg-dark">
        <div className="container mx-auto">
          <div className="relative z-10 overflow-hidden rounded bg-mcolor py-12 px-8 md:p-[70px]">
            <div className="flex flex-wrap items-center -mx-4">
              <div className="w-full px-4 lg:w-1/2">
                <span className="block mb-4   text-xl font-mfont font-medium text-white">
                  Ready to do your best work?
                </span>
                <h2 className="mb-6 text-3xl font-bold leading-tight text-white sm:mb-8 sm:text-[40px]/[48px] lg:mb-0">
                  <span className="xs:block font-mfont"> Get started with </span>
                  <span className="font-mfont">our free trial.</span>
                </h2>
              </div>
              <div className="w-full px-4 lg:w-1/2">
                <div className="flex flex-wrap lg:justify-end">
                  <a
                    href="https://wa.me/919487421228"
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex py-3 my-1  hover:bg-gray-100 mr-4 text-base font-medium transition bg-white rounded-md hover:bg-shadow-1 text-primary px-7"
                  >
                    Get in touch
                  </a>
                  <a
                    href="https://wa.me/919487421228"
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex py-3 my-1 text-base font-medium text-white transition rounded-md bg-blue-800 px-7 hover:bg-opacity-90"
                  >
                    Book a demo
                  </a>
                </div>
              </div>
            </div>
            <div>
              <span className="absolute top-0 left-0 z-[-1]">
                <svg
                  width="189"
                  height="162"
                  viewBox="0 0 189 162"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse
                    cx="16"
                    cy="-16.5"
                    rx="173"
                    ry="178.5"
                    transform="rotate(180 16 -16.5)"
                    fill="url(#paint0_linear)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear"
                      x1="-157"
                      y1="-107.754"
                      x2="98.5011"
                      y2="-106.425"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="white" stop-opacity="0.07" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </linearGradient>
                  </defs>
                </svg>
              </span>
              <span className="absolute bottom-0 right-0 z-[-1]">
                <svg
                  width="191"
                  height="208"
                  viewBox="0 0 191 208"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse
                    cx="173"
                    cy="178.5"
                    rx="173"
                    ry="178.5"
                    fill="url(#paint0_linear)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear"
                      x1="-3.27832e-05"
                      y1="87.2457"
                      x2="255.501"
                      y2="88.5747"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="white" stop-opacity="0.07" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </linearGradient>
                  </defs>
                </svg>
              </span>
            </div>
          </div>
        </div>
      </section>


      <SingleFooter />
      <MMFooter />

    </div >

  )
}

export default Contact